import { render, staticRenderFns } from "./RecordMealModal.vue?vue&type=template&id=7991f7d3&"
import script from "./RecordMealModal.vue?vue&type=script&lang=js&"
export * from "./RecordMealModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports